import { appSchema, tableSchema } from '@nozbe/watermelondb';

export const demoSchema = appSchema({
  version: 3,
  tables: [
    tableSchema({
      name: 'demo_products',
      columns: [
        { name: 'bp_owner_id', type: 'string' },
        { name: 'bp_product_location_id', type: 'string' },
        { name: 'bp_product_barcode', type: 'string' },
        { name: 'bp_product_name', type: 'string', isIndexed: true },
        { name: 'bp_product_category', type: 'string', isIndexed: true },
        { name: 'bp_product_sub_category', type: 'string' },
        { name: 'bp_product_price_type', type: 'string' },
        { name: 'bp_product_unit_of_mass', type: 'string' },
        { name: 'bp_product_mass', type: 'string' },
        { name: 'bp_product_buying_price', type: 'number' },
        { name: 'bp_product_selling_price', type: 'number' },
        { name: 'bp_product_quantity', type: 'number' },
        { name: 'bp_product_size', type: 'string' },
        { name: 'bp_minimum_stock_level', type: 'number' },
        { name: 'bp_product_model', type: 'string' },
        { name: 'bp_product_image', type: 'string' },
        { name: 'bp_product_deleted', type: 'boolean' },
        { name: 'bp_product_is_favourite', type: 'boolean' },
        { name: 'bp_product_created_at', type: 'number' },
        { name: 'bp_product_updated_at', type: 'number' },
        { name: 'bp_product_has_variants', type: 'boolean' },
        { name: 'bp_product_variant_attributes', type: 'string' },
        { name: 'bp_product_variants', type: 'string' },
      ],
    }),
    tableSchema({
      name: 'demo_cart_items',
      columns: [
        { name: 'product_id', type: 'string', isIndexed: true },
        { name: 'variant_id', type: 'string', isIndexed: true },
        { name: 'quantity', type: 'number' },
        { name: 'mass', type: 'number' },
        { name: 'unit_price', type: 'number' },
        { name: 'price_type', type: 'string' },
        { name: 'name', type: 'string' },
        { name: 'unit_of_mass', type: 'string' },
        { name: 'category', type: 'string' },
        { name: 'image', type: 'string' },
        { name: 'created_at', type: 'number' },
      ],
    }),
    tableSchema({
      name: 'demo_order_master_information',
      columns: [
        { name: 'bp_order_master_owner_id', type: 'string', isIndexed: true },
        { name: 'bp_order_master_employee_id', type: 'string' },
        { name: 'bp_order_customer_information', type: 'string' },
        { name: 'bp_order_customer_email_information', type: 'string' },
        { name: 'bp_order_customer_phone_number_information', type: 'string' },
        { name: 'bp_order_customer_information_updated_at', type: 'number' },
        {
          name: 'bp_order_master_order_status',
          type: 'string',
          isIndexed: true,
        },
        { name: 'bp_order_master_payment_information', type: 'string' },
        {
          name: 'bp_order_master_receipt_reference_id',
          type: 'string',
          isIndexed: true,
        },
        { name: 'bp_order_master_receipt_ref_id_updated_at', type: 'number' },
        { name: 'bp_sales_products_information', type: 'string' },
        { name: 'bp_order_master_created_at', type: 'number' },
        { name: 'bp_order_master_updated_at', type: 'number' },
        { name: 'bp_order_master_deleted_at', type: 'number' },
        {
          name: 'bp_order_master_location_id',
          type: 'string',
          isIndexed: true,
        },
        { name: 'bp_order_master_order_total', type: 'number' },
      ],
    }),
    tableSchema({
      name: 'demo_payment_information',
      columns: [
        { name: 'bp_payment_status', type: 'boolean' },
        { name: 'bp_payment_amount', type: 'number' },
        { name: 'bp_payment_amount_received', type: 'number' },
        { name: 'bp_payment_already_paid_amount', type: 'number' },
        { name: 'bp_payment_amount_actually_received', type: 'number' },
        { name: 'bp_payment_amount_due', type: 'number' },
        { name: 'bp_payment_amount_refunded', type: 'number' },
        { name: 'bp_payment_refunds', type: 'string' },
        { name: 'bp_order_information_id', type: 'string', isIndexed: true },
        { name: 'bp_payment_created_at', type: 'number' },
        { name: 'bp_payment_updated_at', type: 'number' },
        { name: 'bp_payment_deleted_at', type: 'number' },
        { name: 'bp_payments', type: 'string' },
        { name: 'bp_payment_location_id', type: 'string', isIndexed: true },
        { name: 'bp_payment_method', type: 'string' },
      ],
    }),
    tableSchema({
      name: 'demo_sales_information',
      columns: [
        { name: 'bp_employee_id', type: 'string' },
        { name: 'bp_owner_id', type: 'string', isIndexed: true },
        { name: 'bp_order_id', type: 'string', isIndexed: true },
        { name: 'bp_product_id', type: 'string', isIndexed: true },
        { name: 'bp_order_quantity', type: 'number' },
        { name: 'bp_order_price', type: 'number' },
        { name: 'bp_order_paid_quantity', type: 'number' },
        { name: 'bp_order_completed', type: 'boolean' },
        { name: 'bp_order_partial_paid', type: 'boolean' },
        { name: 'bp_order_created_at', type: 'number' },
        { name: 'bp_order_updated_at', type: 'number' },
        { name: 'bp_order_deleted_at', type: 'number' },
        { name: 'bp_order_mass', type: 'number' },
        { name: 'bp_order_paid_mass', type: 'number' },
        { name: 'bp_sales_location_id', type: 'string', isIndexed: true },
        { name: 'bp_selling_price_changed', type: 'boolean' },
        { name: 'bp_product_information', type: 'string' },
        { name: 'bp_order_price_type', type: 'string' },
      ],
    }),
  ],
});
